export const PostMessage = {
	VIDEO_SENT_SUCCESS: 'VIDEO_SENT_SUCCESS',
	RECORDING_COMPLETED: 'RECORDING_COMPLETED',
	APP_IS_INACTIVE: 'APP_IS_INACTIVE',
	CROPPED_IMAGE: 'CROPPED_IMAGE',
	CAMERA_PASS_SELECTED: 'CAMERA_PASS_SELECTED',
	SOLVER_PASS_QUESTION_DATA: 'SOLVER_PASS_QUESTION_DATA',
	WHITE_BOARD_DATA: 'WHITE_BOARD_DATA',
	VIDEO_TIMEOUT: 'VIDEO_TIMEOUT',
	NAVIGATE_SOLVE: 'NAVIGATE_SOLVE',
	onClearClick: 'onClearClick',
	openExternalLink: 'OPEN_EXTERNAL_LINK',
	USER_CREDENTIALS: 'USER_CREDENTIALS'
};

export const SolveType = {
	CAMERA: 'CAMERA',
	WHITE_BOARD: 'WHITE_BOARD'
};
